import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { Copy } from "~/components/Copy/Copy";
import { Group, GroupItem } from "~/components/group";
import { formatAddress } from "~/utils/format";
import { formatNumber, formatPrice } from "~/utils/number-format";
import { TokenIcon } from "~/components/TokenIcon";
import { CreateOrder } from "~/types";
import { useState } from "react";
import { IconExchange2 } from "~/components/Iconfont/Iconfont";
import { Skeleton } from "antd-mobile";

type QuickBuyOrderDetailProps = {
    order?: CreateOrder;
    isLoading: boolean;
};

const QuickBuyOrderDetail: React.FC<QuickBuyOrderDetailProps> = ({
    order,
    isLoading,
}) => {
    const { t } = useTranslation();
    const [currentUnitPriceFrom, setCurrentUnitPriceFrom] = useState(true);

    return (
        <div className="mt-[12px] px-4">
            <Group>
                <GroupItem
                    label={t("type")}
                    value={
                        <span className={clsx("text-text_buy")}>
                            {"Market"}
                            {" / "}
                            {t("buy")}
                        </span>
                    }
                    noBorderB={true}
                />
                <GroupItem
                    label={t("unit_price")}
                    value={
                        <div className="flex items-center">
                            {!order || isLoading ? (
                                <Skeleton
                                    className="w-[180px] h-[22px] rounded"
                                    animated
                                />
                            ) : (
                                <>
                                    {currentUnitPriceFrom ? (
                                        <span>
                                            1{" "}
                                            {order.swap_info?.to?.symbol.toUpperCase()}{" "}
                                            ={" "}
                                            {formatNumber(
                                                order.swap_info.unit_price.to
                                            )}{" "}
                                            {order.swap_info?.from?.symbol?.toUpperCase()}
                                        </span>
                                    ) : (
                                        <span>
                                            1{" "}
                                            {order.swap_info?.from?.symbol?.toUpperCase()}{" "}
                                            ={" "}
                                            {formatNumber(
                                                order.swap_info.unit_price.from
                                            )}{" "}
                                            {order.swap_info?.to?.symbol.toUpperCase()}
                                        </span>
                                    )}
                                    <IconExchange2
                                        className="text-[16px] text-text_1 ml-[4px] "
                                        onClick={() =>
                                            setCurrentUnitPriceFrom(
                                                !currentUnitPriceFrom
                                            )
                                        }
                                    />
                                </>
                            )}
                        </div>
                    }
                />
                <GroupItem
                    label={t("to")}
                    value={
                        !order || isLoading ? (
                            <Skeleton
                                className="w-[160px] h-[22px] rounded"
                                animated
                            />
                        ) : (
                            <Copy copyText={order.to}>
                                <span>{formatAddress(order.to)}</span>
                            </Copy>
                        )
                    }
                />
                <GroupItem
                    label={t("network")}
                    value={
                        !order || isLoading ? (
                            <Skeleton
                                className="w-[80px] h-[22px] rounded"
                                animated
                            />
                        ) : (
                            <div className="flex items-center justify-center">
                                <span className="mr-[4px]">
                                    {order.swap_info?.to?.chain_name}
                                </span>
                                <TokenIcon
                                    icon={order.swap_info?.to?.chain_logo}
                                    size="mini"
                                />
                            </div>
                        )
                    }
                />
                <GroupItem
                    label={t("fee")}
                    value={
                        !order || isLoading ? (
                            <Skeleton
                                className="w-[200px] h-[22px] rounded"
                                animated
                            />
                        ) : (
                            <span>
                                {formatNumber(order.gas_data.gas_fee)}{" "}
                                {order.gas_data.gas_currency.toUpperCase()} ~{" "}
                                {formatPrice(order.gas_data.gas_usd)}
                            </span>
                        )
                    }
                />
            </Group>
        </div>
    );
};

export default QuickBuyOrderDetail;
